import React from 'react'
import CollectionMainPage from "../page/CollectionMainPage"


function NoseRingsPage({categoryType}) {
  return (
    <CollectionMainPage categoryType={categoryType}/>
  )
}

export default NoseRingsPage